<template>
  <div class="success-stories-page">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
        
        </div>
      </div>
    </section>

    <section class="stories">
      <div class="container">
        <div class="story">
          <h2>1.AI Predictive Maintenance System Development for a Multinational Power Battery Manufacturer</h2>
          <div class="story-content">
            
            <div class="story-text">
              <p>A globally leading power battery giant was incurring over 40 million yuan in annual output value losses due to unplanned equipment downtime and improper allocation of maintenance resources—on top of high maintenance costs.</p>
              <p>By deploying an AI predictive maintenance system and leveraging data and algorithms, the company achieved accurate fault prediction. The fault prediction accuracy rate exceeded 85%, cutting unplanned downtime by over 140 hours in six months, boosting annual efficiency by nearly 10 million yuan, and successfully transitioning to predictive maintenance.</p>
            </div>
          </div>
        </div>

        <div class="story">
          <h2>2.Geopolitical Risk Strategy Overhaul for a Semiconductor Company</h2>
          <div class="story-content">
            
            <div class="story-text">
              <p>A semiconductor design firm confronted risks of core equipment supply interruptions amid U.S.-China tech trade tensions. In 2024, shifts in geopolitical policies resulted in delayed delivery of 2-3 critical orders, along with a 3%-4% drop in its market share.</p>
              <p>Developed a geopolitical risk model and mitigated international political and economic risks through supply chain regionalization and product diversification. This effort significantly improved supply chain stability (95%-97%). Amid the global chip shortage, it also bucked the trend to expand into new markets in Japan and India, while strengthening its risk resilience through patent collaborations.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta">
      <div class="container">
        <h2>Ready to Write Your Success Story?</h2>
        <p>Schedule a free consultation to discuss how we can help your company achieve its goals.</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SuccessStoriesPage'
}
</script>

<style scoped>
.hero {
  background-image: url('../assets/无国界切图/Success\ Stories.png');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0 8rem 0; 
  padding-top: calc(8rem + 100px);
  text-align: center;
  position: relative;
  width: 100%;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
}

.stories {
  background-color: black;
  color: white;
  padding: 6rem 0;
  width: 100%;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.story {
  margin-bottom: 5rem;
  text-align: left;
}

.story:last-child {
  margin-bottom: 0;
}

.story h2 {
  font-size: 30px;
  margin-bottom: 0.5rem;
}

.meta {
  color: #aaa;
  font-size: 1rem;
  margin-bottom: 2rem;
}

.story-content {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.story-content img {
  flex: 1;
  border-radius: 8px;
  max-width: 100%;
}

.story-text {
  flex: 2;
}

.story-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}

blockquote {
  border-left: 4px solid var(--primary-color);
  padding: 1rem 1.5rem;
  margin: 2rem 0;
  font-style: italic;
  background-color: #111;
}

blockquote cite {
  display: block;
  margin-top: 1rem;
  font-weight: bold;
  font-style: normal;
  color: #aaa;
}

.cta {
  background-color: var(--bg-light);
  color: black;
  padding: 6rem 0;
  text-align: center;
  width: 100%;
}

.cta h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.cta p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.cta-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.cta-button:hover {
  background-color: var(--secondary-color);
}

@media (max-width: 768px) {
  .story-content {
    flex-direction: column;
  }
  
  .story-content img {
    width: 100%;
  }
  
  .hero h1 {
    font-size: 2rem;
  }
}
</style>